import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Client, ClientDto} from './client';
import {Page, PageDto} from '../core/pagination/page';
import { HttpClient, HttpParams } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {ClientPageRequest} from './client-page-request';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private http = inject(HttpClient);

  getClienten$(pageRequest: ClientPageRequest): Observable<Page<Client>> {
    return this.http.post<PageDto<ClientDto>>(`${environment.apiUrl}/clienten/page`, pageRequest)
      .pipe(map(pageDto => new Page<Client>(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => Client.deserialize(dto))
      )));
  }

  postClient$(client: Client): Observable<Client> {
    return this.http.post<ClientDto>(`${environment.apiUrl}/clienten`, client)
      .pipe(map(dto => Client.deserialize(dto)));
  }

  getClientByNummer$(nummer: string): Observable<Client> {
    const params = new HttpParams().set('nummer', nummer);
    return this.http.get<ClientDto>(`${environment.apiUrl}/clienten`, {params})
      .pipe(map(dto => Client.deserialize(dto)));
  }

  getClientById$(id: string): Observable<Client> {
    return this.http.get<ClientDto>(`${environment.apiUrl}/clienten/${id}`)
      .pipe(map(dto => Client.deserialize(dto)));
  }

  getClientenByIds$(ids: Array<string>): Observable<Array<Client>> {
    return this.http
      .post<Array<ClientDto>>(`${environment.apiUrl}/clienten/ids`, {ids})
      .pipe(map(dtos => dtos.map(dto => Client.deserialize(dto))));
  }

  updateClient$(client: Client): Observable<Client> {
    return this.http.put<ClientDto>(`${environment.apiUrl}/clienten/${client.getId()}`, client)
      .pipe(map(dto => Client.deserialize(dto)));
  }

  archiveer(id: string): Observable<Client> {
    return this.http.delete<ClientDto>(`${environment.apiUrl}/clienten/${id}`)
      .pipe(map(dto => Client.deserialize(dto)));
  }

  activeer(id: string): Observable<Client> {
    return this.http.put<ClientDto>(`${environment.apiUrl}/clienten/${id}/activeer`, {})
      .pipe(map(dto => Client.deserialize(dto)));
  }
}
